<template>
	<div class="state-box">
		<p class="title">
			{{ state.name }}
		</p>
		<hr>
		<p class="title mb-3">
			{{ state.total }}
		</p>
		<div class="state-box-container">
			<div class="state-box-background"
				:style="`background-color: ${state.color};
					height: ${backgroundHeight}%`">
				<span class="number"
					:style="`color: ${state.color}`">
					{{ state.value }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
	function backgroundHeight() {
		const { value, total } = this.state;
		return total === 0 ? 0 : ((value / total) * 100);
	}

	export default {
		name: 'state-box',
		computed: {
			backgroundHeight,
		},
		props: {
			state: {
				default: () => {},
				required: true,
				type: Object,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.state-box {
		color: map-get($colors, realtime-label);
		font-family: map-get($map: $fonts, $key: medium);
		padding: 8px 13.5px 15px;
		text-align: center;
		width: 111.3px;

		&-container {
			background-color: map-get($colors, state-box);
			height: 136.9px;
			position: relative;
		}

		&-background {
			bottom: 0px;
			position: absolute;
			width: 100%;
		}

		hr {
			border-color: rgba(0, 0, 0, .13);
			margin-top: 0px;
		}

		p.title {
			font-size: map-get($map: $sizes, $key: fourteen) !important;
			margin-bottom: 5px;
		}

		span.number {
			background-color: white;
			border: 1px solid rgba(0, 0, 0, .2);
			border-radius: 15px;
			bottom: 11px;
			display: block;
			font-family: map-get($fonts, bold);
			font-size: 16.1px;
			height: 21.9px;
			line-height: 21.9px;
			left: 0px;
			margin: 0 auto;
			position: relative;
			right: 0px;
			width: 42.5px;
		}

		&:nth-child(6) {
			border-right: 2px solid rgba(0, 0, 0, .13);
		}
	}
</style>


// WEBPACK FOOTER //
// StateBox.vue?05f94eda